import { render, staticRenderFns } from "./kycPreferences.vue?vue&type=template&id=0ed8ddbe&scoped=true"
import script from "./kycPreferences.vue?vue&type=script&lang=js"
export * from "./kycPreferences.vue?vue&type=script&lang=js"
import style0 from "./kycPreferences.vue?vue&type=style&index=0&id=0ed8ddbe&prod&scoped=true&lang=css"
import style1 from "./kycPreferences.vue?vue&type=style&index=1&id=0ed8ddbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed8ddbe",
  null
  
)

export default component.exports